module.exports = {
  MAX_IMAGE_SIZE: 2097152, //2MB
  MAX_FILE_SIZE: 20971520, //20MB,
  YEAR_LIMIT_BELOW: 2020,
};
